import { DateTime } from 'ts-luxon'
import { computed, ref } from 'vue'
import { useAuth } from '@/entities/Auth'

const useModel = () => {
  const time = ref('')
  const auth = useAuth()

  /**
   * Вычисляем значение часового пояса
   */
  const timeZone = computed(() => {
    const time_zone = auth.user?.time_zone

    if (!time_zone) return 'UTC+3'
    return 'UTC' + time_zone
  })

  /**
   * Вычисляем текущее время, реализовать смещение
   * в зависимости от часового пояса пользователя
   */
  const getCurrentTime = () => {
    time.value = DateTime.now().setZone(timeZone.value).toFormat('HH:mm:ss')
  }

  return {
    time,

    getCurrentTime,
  }
}

export default useModel
